module.exports = __webpack_public_path__ + "media/icons/offer-details-automat-630996a8.png";